import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Coupeongle = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52.66 120.81">
  <G fill={color}>
    <Path d="M50.78.81c-1.26-.89-2.89-1.06-4.31-.44-.11.05-11.08,4.75-21.03,4.75S6.53.53,6.45.49C5.03-.24,3.33-.15,2,.73.67,1.6-.09,3.13,0,4.72l6.52,100.31c.58,8.85,9.27,15.79,19.8,15.79s19.22-6.94,19.8-15.79L52.65,4.72c.1-1.54-.61-3.02-1.87-3.91ZM37.29,104.45c-.27,4.14-5.18,7.51-10.96,7.51s-10.69-3.37-10.96-7.51L9.3,11.16c4.24,1.41,10.01,2.81,16.14,2.81,6.54,0,13.2-1.61,17.93-3.08l-6.08,93.56Z"/>
    <Path d="M12.72,20.71c-.38,2.41,1.26,4.68,3.68,5.07.19.03,4.61.72,9.56.72s9.99-.68,10.21-.71c2.42-.33,4.12-2.56,3.8-4.98-.32-2.42-2.54-4.11-4.98-3.8-.05,0-4.74.63-9.03.63s-8.14-.61-8.17-.61c-2.42-.39-4.68,1.27-5.06,3.68Z"/>
    <Path d="M26.33,31.29c-7.05,0-11.79,4.98-11.79,12.38,0,5.55,6.65,53.36,7.41,58.79.31,2.19,2.18,3.82,4.39,3.82s4.08-1.63,4.39-3.82c.76-5.43,7.41-53.24,7.41-58.79,0-7.41-4.74-12.38-11.79-12.38ZM26.33,68.83c-1.64-12.54-2.94-23.16-2.94-25.15,0-3.11,1.48-3.53,2.94-3.53s2.94.42,2.94,3.53c0,2-1.3,12.61-2.94,25.15Z"/>
  </G>
</Svg>
);
};

export default Coupeongle;
